import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=4352fe06&scoped=true&"
import script from "./distributionList.vue?vue&type=script&lang=js&"
export * from "./distributionList.vue?vue&type=script&lang=js&"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=4352fe06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352fe06",
  null
  
)

export default component.exports